import React from 'react';
import { Box, Paper, CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2)
  },
  loadingText: {
    color: theme.palette.text.secondary
  }
}));

const LoadingSkeleton = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <CircularProgress />
      <Typography variant="body1" className={classes.loadingText}>
        Loading insights...
      </Typography>
    </Paper>
  );
};

export default LoadingSkeleton; 